export const getDefaultWorkspace = (user) => {
  return user?.Workspaces?.find((ws) => ws?.isDefault);
};
